import { render, staticRenderFns } from "./PIcon.vue?vue&type=template&id=01344efb&scoped=true"
import script from "./PIcon.vue?vue&type=script&lang=js"
export * from "./PIcon.vue?vue&type=script&lang=js"
import style0 from "./PIcon.vue?vue&type=style&index=0&id=01344efb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01344efb",
  null
  
)

export default component.exports